// MODULES
import React from "react";

// COMPONENTS
import EditableField from "@routes/Cob/components/EditableField/EditableField";
import FieldsCollection from "@components/FieldsCollection/FieldsCollection";
import OptionsList from "@routes/Cob/components/OptionsList/OptionsList";
import NumberField from "@routes/Cob/components/NumberField/NumberField";
import Select from "@components/Select/Select";
import QuestionField from "@routes/Cob/components/QuestionField/QuestionField";

// HELPERS
import {createClassName} from "@helpers/utils";


export default class Collection extends React.PureComponent {

	render() {
		const {props} = this;
		const {index, fields, validFields, numberLocaleFormatter, onFieldChange, onFieldBlur, onSelectChange, onOptionsListChange} = props;
		const classes = createClassName("Cob-Questionnaire-Collection", {
			"first": index === 0,
		});

		return (
			<div className={classes}>
				<h3>Frågor enligt penningtvättslagen</h3>

				<FieldsCollection
					fields={[
						{
							render: (
								<FieldsCollection
									fieldsPerRow={fields.checkbox_customer_reason_business_relationship.index === 2 ? 2 : 1}
									fields={[
										{
											render: (
												<QuestionField
													Component={Select}
													description="Vad är den primära anledningen till affärsförbindelsen med Nord FK?"
													label="Välj"
													name={fields.checkbox_customer_reason_business_relationship.name}
													selectedIndex={fields.checkbox_customer_reason_business_relationship.index}
													options={fields.checkbox_customer_reason_business_relationship.options}
													onChange={onSelectChange}
												/>
											),
										}, {
											display: fields.checkbox_customer_reason_business_relationship.index === 2,
											render: (
												<EditableField
													className="other-field"
													name="customer_reason_business_relationship_other"
													label="Annat"
													value={fields.customer_reason_business_relationship_other || ""}
													valid={validFields.customer_reason_business_relationship_other}
													onChange={onFieldChange}
													onBlur={onFieldBlur}
												/>
											),
										},
									]}
								/>
							),
						}, {
							render: (
								<FieldsCollection
									fieldsPerRow={fields.checkbox_customer_kyc_purpose.index === 6 ? 2 : 1}
									fields={[
										{
											render: (
												<QuestionField
													Component={Select}
													description="Vad är syftet med ditt eller företagets investering?"
													label="Välj"
													name={fields.checkbox_customer_kyc_purpose.name}
													selectedIndex={fields.checkbox_customer_kyc_purpose.index}
													options={fields.checkbox_customer_kyc_purpose.options}
													onChange={onSelectChange}
												/>
											),
										}, {
											display: fields.checkbox_customer_kyc_purpose.index === 6,
											render: (
												<EditableField
													className="other-field"
													name="customer_kyc_purpose_other"
													label="Annat"
													value={fields.customer_kyc_purpose_other || ""}
													valid={validFields.customer_kyc_purpose_other}
													onChange={onFieldChange}
													onBlur={onFieldBlur}
												/>
											),
										}
									]}
								/>
							),
						}, {
							render: (
								<FieldsCollection
									fieldsPerRow={fields.checkbox_customer_kyc_inv.index === 2 ? 2 : 1}
									fields={[
										{
											render: (
												<QuestionField
													Component={Select}
													description="För vems räkning investerar du?"
													label="Välj"
													name={fields.checkbox_customer_kyc_inv.name}
													selectedIndex={fields.checkbox_customer_kyc_inv.index}
													options={fields.checkbox_customer_kyc_inv.options}
													onChange={onSelectChange}
												/>
											),
										}, {
											display: fields.checkbox_customer_kyc_inv.index === 2,
											render: (
												<EditableField
													className="other-field"
													name="customer_kyc_inv_other"
													label="Annat"
													value={fields.customer_kyc_inv_other || ""}
													valid={validFields.customer_kyc_inv_other}
													onChange={onFieldChange}
													onBlur={onFieldBlur}
												/>
											),
										}
									]}
								/>
							),
						}, {
							render: (
								<FieldsCollection
									fieldsPerRow={fields.checkbox_aml_origin.index === 5 ? 2 : 1}
									fields={[
										{
											render: (
												<QuestionField
													Component={Select}
													description="Varifrån kommer pengarna du investerar?"
													label="Välj"
													name={fields.checkbox_aml_origin.name}
													selectedIndex={fields.checkbox_aml_origin.index}
													options={fields.checkbox_aml_origin.options}
													onChange={onSelectChange}
												/>
											)
										}, {
											display: fields.checkbox_aml_origin.index === 5,
											render: (
												<EditableField
													className="other-field"
													name="aml_origin_other_desc"
													label="Annat"
													value={fields.aml_origin_other_desc || ""}
													valid={validFields.aml_origin_other_desc}
													onChange={onFieldChange}
													onBlur={onFieldBlur}
												/>
											),
										}
									]}
								/>
							),
						}, {
							render: (
								<FieldsCollection
									fieldsPerRow={fields.checkbox_customer_kyc_empl.index === 6 ? 2 : 1}
									fields={[
										{
											render: (
												<QuestionField
													Component={Select}
													description="Vilken anställningsform har du?"
													label="Välj"
													name={fields.checkbox_customer_kyc_empl.name}
													selectedIndex={fields.checkbox_customer_kyc_empl.index}
													options={fields.checkbox_customer_kyc_empl.options}
													onChange={onSelectChange}
												/>
											),
										}, {
											display: fields.checkbox_customer_kyc_empl.index === 6,
											render: (
												<EditableField
													className="other-field"
													name="customer_kyc_empl_other"
													label="Annat"
													value={fields.customer_kyc_empl_other || ""}
													valid={validFields.customer_kyc_empl_other}
													onChange={onFieldChange}
													onBlur={onFieldBlur}
												/>
											),
										}
									]}
								/>
							),
						}, {
							render: (
								<FieldsCollection
									fields={[
										{
											render: (
												<QuestionField
													Component={Select}
													description="Hur stor är din nettoinkomst/mån?"
													label="Välj"
													name={fields.checkbox_customer_kyc_net_income.name}
													selectedIndex={fields.checkbox_customer_kyc_net_income.index}
													options={fields.checkbox_customer_kyc_net_income.options}
													onChange={onSelectChange}
												/>
											),
										},
									]}
								/>
							),
						}, {
							render: (
								<FieldsCollection
									fieldsPerRow={fields.checkbox_customer_kyc_deposit.index === 7 ? 2 : 1}
									fields={[
										{
											render: (
												<QuestionField
													Component={Select}
													description="Från vilken bank/institut kommer du generellt göra överföringar?"
													label="Välj"
													name={fields.checkbox_customer_kyc_deposit.name}
													selectedIndex={fields.checkbox_customer_kyc_deposit.index}
													options={fields.checkbox_customer_kyc_deposit.options}
													onChange={onSelectChange}
												/>
											),
										}, {
											display: fields.checkbox_customer_kyc_deposit.index === 7,
											render: (
												<EditableField
													className="other-field"
													name="customer_kyc_deposit_other"
													label="Annat"
													value={fields.customer_kyc_deposit_other || ""}
													valid={validFields.customer_kyc_deposit_other}
													onChange={onFieldChange}
													onBlur={onFieldBlur}
												/>
											),
										},
									]}
								/>
							),
						}, {
							render: (
								<FieldsCollection
									fieldsPerRow={fields.checkbox_aml_origin.index === 5 ? 2 : 1}
									fields={[
										{
											render: (
												<OptionsList
													orientation="horizontal"
													type="radio"
													name="radio_aml_purpose_gains"
													description="Är syftet med att investera i finansiella instrument annat än att nå avkastning?"
													options={fields.radio_aml_purpose_gains.options}
													onChange={onOptionsListChange}
												/>
											)
										},
									]}
								/>
							),
						}, {
							render: (
								<FieldsCollection
									fields={[
										{
											render: (
												<QuestionField
													Component={NumberFieldWithName}
													name="customer_kyc_sek_invested"
													description="Hur mycket pengar har du/företaget du företräder investerat i värdepapper och pengar?"
													label="Ange i SEK"
													value={fields.customer_kyc_sek_invested || ""}
													unit={fields.customer_kyc_sek_invested ? " SEK" : undefined}
													valid={validFields.customer_kyc_sek_invested}
													customInputFormatter={numberLocaleFormatter}
													onChange={onFieldChange}
													onBlur={onFieldBlur}
												/>
											),
										},
									]}
								/>
							),
						},
					]}
				/>
			</div>
		);
	}
}

// PRIVATE COMPONENTS
function NumberFieldWithName(props) {
	return <EditableField {...props} Component={NumberField}/>;
}


// WEBPACK FOOTER //
// ./src/routes/Cob/views/Questionnaire/partners/nordfk-cob/Fields/collections/CollectionKyc.js